import React from 'react'
import { SimpleModal } from 'components/Modal'
import Api from 'api'

interface HygienistBrief {
  id: number
  firstName?: string
  lastName?: string
  yearsExperience?: number
  rating?: number
  distance?: number
  photoUrl?: string
}

interface Props {
  isOpen: boolean
  jobId: number
  hygienists: HygienistBrief[]
  onClose: () => void
}

const AvailableHygienistsModal: React.FC<Props> = ({ isOpen, jobId, hygienists, onClose }) => {
  const [error, setError] = React.useState<string>('')
  const [loadingId, setLoadingId] = React.useState<number | null>(null)
  const isUS = ((window as any)?.TempStars?.User?.getCurrentUser?.()?.country === 1) || ((window as any)?.TempStars?.User?.getCurrentUser?.()?.countryStr === 'US')

  const onBook = async (hygienistId: number) => {
    setError('')
    setLoadingId(hygienistId)
    try {
      await Api.instabookHygienist({ jobId, hygienistId })
      onClose()
    } catch (e: any) {
      setError(e?.message || 'Failed to instabook. Please try again.')
    } finally {
      setLoadingId(null)
    }
  }

  return (
    <SimpleModal isOpen={isOpen} onClose={onClose}>
      <div style={{ padding: '1rem', minWidth: 320 }}>
        <h3 style={{ marginTop: 0 }}>Instantly Available Hygienists</h3>
        {error ? <div style={{ color: 'var(--primary-main, #FB7672)', marginBottom: 8 }}>{error}</div> : null}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {hygienists?.length ? hygienists.map((h) => (
            <div key={h.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: 8, border: '1px solid var(--divider, #e0e0e0)', borderRadius: 8 }}>
              {h.photoUrl ? <img src={h.photoUrl} alt="profile" style={{ width: 40, height: 40, borderRadius: 20, objectFit: 'cover' }} /> : <div style={{ width: 40, height: 40, borderRadius: 20, background: '#ddd' }} />}
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600 }}>{h.firstName || ''} {h.lastName || ''}</div>
                <div style={{ fontSize: 12, color: 'var(--text-secondary, #666)' }}>
                  {h.yearsExperience ? `${h.yearsExperience} yrs` : ''} {typeof h.rating === 'number' ? ` · ${h.rating.toFixed(1)}★` : ''} {typeof h.distance === 'number' ? ` · ${(isUS ? (h.distance || 0) * 0.621371 : h.distance)?.toFixed(1)} ${isUS ? 'mi' : 'km'}` : ''}
                </div>
              </div>
              <button className="bigButtonInNewStyle" onClick={() => onBook(h.id)} disabled={loadingId === h.id}>
                {loadingId === h.id ? 'Booking...' : 'Instabook'}
              </button>
            </div>
          )) : <div>No hygienists are instantly available right now.</div>}
          <button className="bigButtonInNewStyle" onClick={onClose}>Close</button>
        </div>
      </div>
    </SimpleModal>
  )
}

export default AvailableHygienistsModal


